//记得在 src\components\lang\zhLoad.js 里面添加对象
const client = {
  msg: {
  }
};
export default client



// WEBPACK FOOTER //
// ./src/page/bd/plan/purchUnloadPlan/lang/index.en.js